import { MY_OFFER_PRODUCTS_TYPES } from "../types/myOfferProductsTypes";

const INITIAL_STATE = {
  createOfferSuccess: null,
  productsDetailsById: null,
  offerProductsList: null,
  exporterOfferProductsList: null,
  exporterLoading: false,
  loading: false,
  error: null,
  
};

const offerProducts = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MY_OFFER_PRODUCTS_TYPES.CREATE_OFFER_PRODUCT_SUCCESS:
      return {
        ...state,
        creating: false,
        createOfferSuccess: action.payload,
        createError: null,
      };

    case MY_OFFER_PRODUCTS_TYPES.GET_PRODUCT_BY_ID_SUCCESS:
      return {
        ...state,
        productsDetailsById: action.payload,
      };
    case MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        offerProductsList: action.payload,
        error: null,
      };

    case MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER:
      return {
        ...state,
        exporterLoading: true,
        exporterError: null,
      };

    case MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER_SUCCESS:
      return {
        ...state,
        exporterLoading: false,
        exporterOfferProductsList: action.payload,
        exporterError: null,
      };

    case MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER_FAILURE:
      return {
        ...state,
        exporterLoading: false,
        exporterError: action.error,
      };

    case MY_OFFER_PRODUCTS_TYPES.DELETE_MY_OFFER_PRODUCT:
      return {
        ...state,
        offerProductsList: action.payload,
      };

    default:
      return state;
  }
};

export default offerProducts;
